import { ApplicationState } from '~/store';
import { StoreAsset } from '~/constants/stores';
import { createSelector } from 'reselect';

export const getStoreConnectStore = (state: ApplicationState) => state.storeConnect;

export const getStoreConnectSelection = createSelector(
  getStoreConnectStore,
  (storeConnectStore): StoreAsset | null => storeConnectStore.storeSelection,
);

export const getStoreConnectRedirectUrl = createSelector(
  getStoreConnectStore,
  (storeConnectStore): string => storeConnectStore.redirectUrl,
);

export const getStoreConnectLoading = createSelector(
  getStoreConnectStore,
  (storeConnectStore): boolean => storeConnectStore.loading,
);

export const getStoreConnectError = createSelector(
  getStoreConnectStore,
  (storeConnectStore) => storeConnectStore.error,
);
